import { render, staticRenderFns } from "./addBoleto.vue?vue&type=template&id=704c25db&scoped=true&"
import script from "./addBoleto.vue?vue&type=script&lang=js&"
export * from "./addBoleto.vue?vue&type=script&lang=js&"
import style0 from "./addBoleto.vue?vue&type=style&index=0&id=704c25db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704c25db",
  null
  
)

export default component.exports